import { FormInfomation } from '@/views_v2/card-list/types';

// 银行卡类型
export enum CardTypeEnum {
  // 储蓄卡
  DebitCard = 0,
  // 信用卡
  CreditCard = 1,
}

// 支持的银行卡
export interface SupportBankCardExtend {
  name: string;
  logo: string;
  // 单日以及单笔限额，单位：元
  transferDayQuota: string;
  transferDealQuota: string;
}

export interface SupportBankCard {
  code: string;
  name: string;
  extendInfo: SupportBankCardExtend;
}

// 用户三要素信息: 身份证号、手机号、真实姓名
export interface UserThreeElements {
  idCardNo: string;
  phone: string;
  userName: string;
}

// 发送短信验证码结果
export interface SendSmsOrBindCardResult {
  cardApplyId: string;
  thirdApplyId: string;
  // 是否需要短信验证码：0 需要 1 已经绑过
  bandStatus: number;
  // 如果不需要发送短信验证码，会同时返回银行卡id
  bankCardId: string;
  success: boolean;
  errMsg: string;
}

// 银行名称和类型
export interface BankInfoOfCardNo {
  bankName: string;
  bankLogo: string;
  cardType: CardTypeEnum;
  /** 校验结果，默认true */
  checkResult?: boolean;
  /** 校验结果描述，若checkResult是false时，会返回错误信息，如： ”当前放款机构不支持绑定兴业银行 储蓄卡，请切换银行卡“ */
  checkMsg?: string;
}

/** 银行卡号查询参数 */
export interface QueryBankInfoParams {
  /** 银行卡号 */
  cardNo: string,
  /** 渠道ID */
  commodityId: string,
  /** 是否需要校验资方支持该银行卡不，默认false */
  checkCapital?: boolean,
  /** 资方code，多资方以_隔开 */
  capitalCode?: string,
}

// 提交验卡绑定
export interface SubmitBankCardResult {
  bankCardId: string;
}


// 绑卡场景类型
export enum BindCardFlowTypeEnum {
  // 提现借款 绑卡
  LEND = 'lend',
  // 还款 绑卡
  REPAY = 'repay',
  /** 授信申请中绑卡: 自营8180绑卡 */
  CREDIT = 'credit',
}

// 绑卡接口参数类型
export interface BindCardParamsTypes {
  // 渠道ID
  commodityId: string;
  // 页面来源
  entryFrom: FormInfomation;

  capitalCode?: string;

  loanOrderId?: string;
}


/** 绑卡页场景对应绑卡申请类型映射
 * [FormInfomation.Profile] 和 [FormInfomation.H5PreApply] 目前不会走进绑卡页面
 */
export const BindCardFlowTypeMap: Partial<Record<FormInfomation, BindCardFlowTypeEnum>> = {
  [FormInfomation.Product]: BindCardFlowTypeEnum.LEND,
  [FormInfomation.Repay]: BindCardFlowTypeEnum.REPAY,
  [FormInfomation.Credit]: BindCardFlowTypeEnum.CREDIT,
};
